import React from 'react';
import PropTypes from 'prop-types';

export const AddressButton = ({ address, onclick, coordinates }) => {
  const onclickPrepare = React.useCallback(
    ev => {
      ev.preventDefault();
      onclick && onclick(coordinates);
    },
    [coordinates, onclick],
  );
  return <button onClick={onclickPrepare}>{address}</button>;
};

AddressButton.propTypes = {
  address: PropTypes.string,
  onclick: PropTypes.func,
  coordinates: PropTypes.array,
};